import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { MyAccountRootState } from '@/domains/MyAccountRootState';

const useMyAccountTypedSelector: TypedUseSelectorHook<MyAccountRootState> =
  useSelector;

export default useMyAccountTypedSelector;
